<!-- 产品-设备详情 -->
<template>
  <div class="md-layout">
    <!-- 卡片 设备详情表格 -->
    <div class="md-layout-item md-size-100">

      <simple-wizard :start-index="startIndex" @update:startIndex="updateIndex" class="plat" wizardClass = "plat">
        <template slot="header"><div></div></template>
        <!-- EVENT -->
        <wizard-tab >
          <template slot="label"> {{$I18n("event_list")}} </template>
          <div>
            <!-- 卡片-主体-查询表单 -->
            <div class="md-layout card-form">
              <div class="md-layout-item md-size-30 md-xsmall-size-50">
                <md-field>
                  <label>{{$I18n("user_id")}}</label>
                  <md-input v-model="eventForm.user_id"/>
                </md-field>
              </div>
              <div class="md-layout-item md-size-30 md-xsmall-size-50">
                <md-field>
                  <label>{{$I18n("push_type")}}</label>
                  <md-select v-model="eventForm.push_type">
                    <md-option :value="0" >{{$I18n("all")}}</md-option>
                    <md-option :value="1" >{{$I18n("msg")}}</md-option>
                    <md-option :value="2" >{{$I18n("email")}}</md-option>
                    <md-option :value="3" >{{$I18n("sms")}}</md-option>
                    <md-option :value="4" >{{$I18n("simple_phone")}}</md-option>
                  </md-select>
                </md-field>
              </div>
              <div class="md-layout-item md-size-30 md-xsmall-size-50">
                <md-field>
                  <label>{{"UID"}}</label>
                  <md-input v-model="eventForm.uid"/>
                </md-field>
              </div>
              <!-- 表单-按钮-重新查询 (只在小屏幕中显示) -->
              <div class="md-layout-item md-size-10 left-layout-item" :style="{'padding-right':0}">
                <md-button class= "left-icon md-info " @click="form_changeEventData">
                  <md-icon>search</md-icon>{{$I18n("search")}}
                </md-button>
              </div>
            </div>
            <md-table v-model="event_tableData">
              <md-table-row slot="md-table-row" slot-scope="{ item }" >
                <md-table-cell :md-label="'ID'">{{ item.id }}</md-table-cell>
                <md-table-cell :md-label="$I18n('user_id')">{{ item.user_id }}</md-table-cell>
                <md-table-cell :md-label="'DevID'">{{ item.dev_id }}</md-table-cell>
                <md-table-cell :md-label="$I18n('push_type')">{{ item.push_type_name }}</md-table-cell>
                <md-table-cell :md-label="$I18n('alarm_event')">{{ item.alarm_event }}</md-table-cell>
                <md-table-cell :md-label="$I18n('cloud_id')">{{ item.link_video_id }}</md-table-cell>
                <md-table-cell :md-label="$I18n('thum_id')">{{ item.link_img_id }}</md-table-cell>
                <md-table-cell :md-label="$I18n('event_time')">{{ timestampToString1000(item.gmt_alarm) }}</md-table-cell>
                <md-table-cell :md-label="$I18n('create_time')">{{ timestampToString1000(item.gmt_create) }}</md-table-cell>
              </md-table-row>
              <md-table-empty-state slot="md-table-empty-state"> {{$I18n("none_data")}} </md-table-empty-state>
            </md-table>
            <table-page :total="totalEven" :pageSize="pageSize" v-model="currentPageEvent"/>
          </div>
        </wizard-tab>
        <!-- PUSH -->
        <wizard-tab >
          <template slot="label"> {{$I18n("push_list")}} </template>
          <div>
            <!-- 卡片-主体-查询表单 -->
            <div class="md-layout card-form">
              <div class="md-layout-item md-size-15 md-xsmall-size-50">
                <md-field>
                  <label>{{$I18n("user_id")}}</label>
                  <md-input v-model="pushForm.link_id"/>
                </md-field>
              </div>
              <div class="md-layout-item md-size-15 md-xsmall-size-50">
                <md-field>
                  <label>{{$I18n("push_type")}}</label>
                  <md-select v-model="pushForm.push_type">
                    <md-option :value="0" >{{$I18n("all")}}</md-option>
                    <md-option :value="1" >{{$I18n("msg")}}</md-option>
                    <md-option :value="2" >{{$I18n("email")}}</md-option>
                    <md-option :value="3" >{{$I18n("sms")}}</md-option>
                    <md-option :value="4" >{{$I18n("simple_phone")}}</md-option>
                  </md-select>
                </md-field>
              </div>
              <div class="md-layout-item md-size-15 md-xsmall-size-50">
                <md-field>
                  <label>{{"UID"}}</label>
                  <md-input v-model="pushForm.uid"/>
                </md-field>
              </div>
              <div class="md-layout-item md-size-15 md-xsmall-size-50">
                <md-field>
                  <label>{{"Token"}}</label>
                  <md-input v-model="pushForm.token"/>
                </md-field>
              </div>
              <div class="md-layout-item md-size-15 md-xsmall-size-50">
                <md-field>
                  <label>{{$I18n("push_type")}}</label>
                  <md-select v-model="pushForm.send_state">
                    <md-option :value="0" >{{$I18n("all")}}</md-option>
                    <md-option :value="1" >{{$I18n("sending")}}</md-option>
                    <md-option :value="2" >{{$I18n("sending_comp")}}</md-option>
                  </md-select>
                </md-field>
              </div>
              <!-- 表单-按钮-重新查询 (只在小屏幕中显示) -->
              <div class="md-layout-item md-size-25 left-layout-item" :style="{'padding-right':0}">
                <md-button class= "left-icon md-info " @click="form_changePushData">
                  <md-icon>search</md-icon>{{$I18n("search")}}
                </md-button>
              </div>
            </div>
            <md-table v-model="push_tableData">
              <md-table-row slot="md-table-row" slot-scope="{ item }" >
                <md-table-cell :md-label="'ID'">{{ item.id }}</md-table-cell>
                <md-table-cell :md-label="$I18n('user_id')">{{ item.link_id }}</md-table-cell>
                <md-table-cell :md-label="'Token'">{{ item.token }}</md-table-cell>
                <md-table-cell :md-label="$I18n('push_type')">{{ item.push_type_name }}</md-table-cell>
                <md-table-cell :md-label="$I18n('platform_flag')">{{ item.platform_flag }}</md-table-cell>
                <md-table-cell :md-label="$I18n('send_status')">{{ item.send_state_name }}</md-table-cell>
                <md-table-cell :md-label="$I18n('send_result')">{{ item.send_result }}</md-table-cell>
                <md-table-cell :md-label="$I18n('send_res_text')">{{ item.send_result_desc }}</md-table-cell>
                <md-table-cell :md-label="$I18n('send_time')">{{ timestampToString(item.send_time) }}</md-table-cell>
                <md-table-cell :md-label="$I18n('create_time')">{{ timestampToString(item.create_time) }}</md-table-cell>
                <md-table-cell :md-label="$I18n('operate')" class="button-box">
                  <div @click="open_modal(item)" @click.stop style='color: #00bcd4;cursor: pointer;'>
                    {{$I18n("more_info")}}
                  </div>
                </md-table-cell>
              </md-table-row>
              <md-table-empty-state slot="md-table-empty-state"> {{$I18n("none_data")}} </md-table-empty-state>
            </md-table>
            <table-page :total="totalPush" :pageSize="pageSize" v-model="currentPagePush"/>
          </div>
        </wizard-tab>

      </simple-wizard>
    </div>
    <!-- 弹窗-修改产品 -->
    <simple-modal ref="modal" :title="$I18n('details')" :right="true" :submitBtn="false" >
      <!-- 弹窗-主体 -->
      <template slot="body">
        <!-- 弹窗-表单 -->
        <div>
          <common-form-item 
            v-for="item in form_modalData" 
            v-model="modalData[item.keys]" 
            :key="item.keys" v-bind="item"
          />
        </div>
      </template>
    </simple-modal>
  </div>
</template>
<script>
import { timestampToString, timestampToString1000 } from "@/common/tools.js";
import { SimpleWizard, WizardTab } from "@/components";

export default {
  components: {
    SimpleWizard,
    WizardTab,
  },
  data() {
    return {
      eventForm:{
        user_id : "",
        push_type : 0,
        uid : "",
      },
      eventSearch:{
        user_id : "",
        push_type : 0,
        uid : "",
      },

      pushForm:{
        link_id : "",
        uid : "",
        token : "",
        push_type : 0,
        send_state : 0,
      },
      pushSearch:{
        link_id : "",
        uid : "",
        token : "",
        push_type : 0,
        send_state : 0,
      },

      tableEventInitData : [], // 表格数据
      tablePushInitData : [], // 表格数据
      totalEven : 0,
      totalPush : 0,

      pageSize : 10,
      currentPageEvent : 1,
      currentPagePush : 1,

      modalData:{},
      startIndex : 0,
    };
  },
  mounted : function() {
    this.api_getEventPageData();
    this.api_getPushPageData();
  },
  watch: {
    '$root.state':{
      handler(){
        return 
      },
      immediate: true,
      deep: true,
    },
    currentPageEvent(){
      this.api_getEventPageData();
    },
    currentPagePush(){
      this.api_getPushPageData();
    },
  },
  methods: {
    timestampToString1000: timestampToString1000,
    timestampToString: timestampToString,
    updateIndex(newIndex){
      this.startIndex = newIndex;
    },
    open_modal(item){
      this.modalData = item;
      this.$refs.modal.open();
    },
    api_getPushPageData(){ // API-获取页面信息
      // 获取角色
      this.$api.getAlarmPush({
          ...this.pushSearch,
          page_size: this.pageSize,
          page_no  : this.currentPagePush,
      })
        .then(this.$Then(res => {
          this.tablePushInitData = res.data;
          this.totalPush = res.count;
        }))
        .catch(this.$Catch(this.$I18n("get_error"),() => {
          this.tablePushInitData = [];
          this.totalPush = 0;
        }))
    },
    api_getEventPageData(){
      this.$api.getAlarmLog({
          ...this.eventSearch,
          page_size: this.pageSize,
          page_no  : this.currentPageEvent,
        })
        .then(this.$Then(res => {
          // console.log(res.data)
          this.tableEventInitData = res.data;
          this.totalEven = res.count;
        }))
        .catch(this.$Catch(this.$I18n("get_error"),() => {
          this.tableEventInitData = [];
          this.totalEven = 0;
        }))
    },
    form_changeEventData(){
      this.eventSearch = {...this.eventForm}
      this.currentPageEvent = 1;
      this.api_getEventPageData();
    },
    form_changePushData(){
      this.pushSearch = {...this.pushForm}
      this.currentPagePush = 1;
      this.api_getPushPageData();
    },
  },
  computed: {
    event_tableData(){
      return this.tableEventInitData.map(i => {
        let push_type_name = this.$I18n("unknow");
        if(i.push_type === 1){
          push_type_name = this.$I18n("msg");
        } else if(i.push_type === 2){
          push_type_name = this.$I18n("email");
        } else if(i.push_type === 3){
          push_type_name = this.$I18n("sms");
        } else if(i.push_type === 4){
          push_type_name = this.$I18n("simple_phone");
        }
        return {
          ...i,
          push_type_name,
        }
      })
    },
    push_tableData(){
      return this.tablePushInitData.map(i => {
        let push_type_name = this.$I18n("unknow");
        if(i.push_type === 1){
          push_type_name = this.$I18n("msg");
        } else if(i.push_type === 2){
          push_type_name = this.$I18n("email");
        } else if(i.push_type === 3){
          push_type_name = this.$I18n("sms");
        } else if(i.push_type === 4){
          push_type_name = this.$I18n("simple_phone");
        }
        let send_state_name = this.$I18n("unknow");
        if(i.send_state === 1){
          send_state_name = this.$I18n("sending");
        } else if(i.send_state === 2){
          send_state_name = this.$I18n("sending_comp");
        }
        let sync_state_name = this.$I18n("unknow");
        if(i.sync_state === 1){
          sync_state_name = this.$I18n("wait_sync");
        } else if(i.sync_state === 2){
          sync_state_name = this.$I18n("succ_num");
        } else if(i.sync_state === 3){
          sync_state_name = this.$I18n("fail_num");
        }

        return {
          ...i,
          push_type_name,
          send_state_name,
          sync_state_name,
          send_time_date : this.timestampToString(i.send_time),
          sync_time_date : this.timestampToString(i.sync_time),
          created_thing_time_date : this.timestampToString1000(i.gmt_create),
        }
      })
    },
    form_modalData(){
      return [
        {
          label   : 'ID',
          keys    : "id",
          type    : "input",
          disabled: true,
        },
        {
          label   : this.$I18n('user_id'),
          keys    : "link_id",
          type    : "input",
          disabled: true,
        },
        {
          label   : 'Token',
          keys    : "token",
          type    : "input",
          disabled: true,
        },
        {
          label   : this.$I18n('push_type'),
          keys    : "push_type_name",
          type    : "input",
          disabled: true,
        },
        {
          label   : this.$I18n('platform_flag'),
          keys    : "platform_flag",
          type    : "input",
          disabled: true,
        },
        {
          label   : this.$I18n('push_content'),
          keys    : "push_msg",
          type    : "input",
          disabled: true,
        },
        {
          label   : this.$I18n('push_param'),
          keys    : "push_param",
          type    : "input",
          disabled: true,
        },
        {
          label   : this.$I18n('send_status'),
          keys    : "send_state_name",
          type    : "input",
          disabled: true,
        },
        {
          label   : this.$I18n('send_result'),
          keys    : "send_result",
          type    : "input",
          disabled: true,
        },
        {
          label   : this.$I18n('send_res_text'),
          keys    : "send_result_desc",
          type    : "input",
          disabled: true,
        },
        {
          label   : this.$I18n('sync_state'),
          keys    : "sync_state_name",
          type    : "input",
          disabled: true,
        },
        {
          label   : this.$I18n('send_time'),
          keys    : "send_time_date",
          type    : "input",
          disabled: true,
        },
        {
          label   : this.$I18n('sync_time'),
          keys    : "sync_time_date",
          type    : "input",
          disabled: true,
        },
        {
          label   : this.$I18n('created_thing_time'),
          keys    : "created_thing_time_date",
          type    : "input",
          disabled: true,
        },
      ]
    },
  },
}
</script>
<style lang="scss" scoped>
  .left-btn {
    text-align:left;
  }
  .md-date-form-item {
    height : 36px;
    border : none;
  }
  .left-table{
    margin-top: 16px;
  }
  .card-form {
    margin-top: 12px;
  }
  // 左侧表单对齐表格
  .left-layout-item{
    padding-rigth:8px;
    padding-left:8px;
  }
  // 表单右侧对齐表格
  .right-layout-item{
    text-align: right;
    padding:0;
  }
  // 弹窗
  .lg-modal .modal-container{
    width : 80%;
    max-width: unset;
  }
  // 表格的ID列
  .numbers {
    width: 160px;
  }
  // 表格的按钮列
  .button-box {
    width: 240px;
  }
  .md-table .md-table-head:last-child {
    text-align: right;
  }

</style>
